import { RouteConfig } from "vue-router";
import { forbiddenRoleRouteGuard } from "@/lib/routerGuards";
import config from "@/config";
import { enrichRouteMeta } from "@/router/helpers";
import { profileRoutes } from "@/router/routes/profile";
import { ROLES } from "@/const";

const routes: RouteConfig[] = [
  ...(config.featureLoginAsUser
    ? [
        {
          path: "/login/token/:token",
          name: "loginToken",
          component: () => import("@/views/PageLoginToken"),
          props: true,
        },
      ]
    : []),
  {
    path: "/logout",
    name: "logout",
  },
  ...(!config.featurePrivateProfile ? profileRoutes : []),
  {
    path: "/discover",
    name: "discover",
    props: {
      default: () => ({ onFeed: false }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import("@/views/UnlockFeed"),
    },
    beforeEnter(_, __, next) {
      const forbiddenRole = ROLES.CREATOR;
      forbiddenRoleRouteGuard(forbiddenRole) ? next() : next({ name: "home" });
    },
  },
  {
    path: "/discover/feed",
    name: "discoverFeed",
    props: {
      default: () => ({ onFeed: true }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import("@/views/UnlockFeed"),
    },
    beforeEnter(_, __, next) {
      const forbiddenRole = ROLES.CREATOR;
      forbiddenRoleRouteGuard(forbiddenRole) ? next() : next({ name: "home" });
    },
  },
  {
    path: "/complaints",
    name: "complaints",
    components: {
      default: () => import("@/views/PageComplaints"),
    },
  },
];

export default routes.map(route => enrichRouteMeta(route, {}));
